import React from 'react';
import { useParams } from 'react-router-dom';
import { fleetAPI } from '../services/api';
import TripHistory from '../components/TripHistory';

export default function DriverView() {
  const { id } = useParams();
  return (
    <TripHistory
      title="Driver Trip History"
      subtitle="All LR trips recorded against this driver"
      api={fleetAPI.drivers}
      entityId={id}
      fileLabel="driver"
      entityCard={(data) => {
        const d = data.driver || {};
        return (
          <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-md p-4 flex flex-wrap gap-x-8 gap-y-2" data-testid="driver-detail-card">
            <Info label="Name" value={d.name} />
            <Info label="Mobile" value={d.mobile} mono />
            <Info label="License No." value={d.license_number} mono />
            <Info label="License Expiry" value={d.license_expiry} />
            <Info label="Emergency Contact" value={d.emergency_contact} mono />
            <Info label="Status" value={d.status} />
          </div>
        );
      }}
    />
  );
}

function Info({ label, value, mono }) {
  return (
    <div className="min-w-0">
      <p className="text-[10px] text-slate-400 uppercase tracking-wide">{label}</p>
      <p className={`text-sm font-medium text-slate-800 dark:text-slate-200 ${mono ? 'font-mono' : ''}`}>{value || '—'}</p>
    </div>
  );
}
